module.exports = __webpack_public_path__ + "img/14_1.934d20ea.png";